import { useTranslation } from 'react-i18next';

const destinations = {
  de: 'https://www.mandira-ayurveda.at/beratung-christina#call',
  en: 'https://www.mandira-ayurveda.at/en/consultation-christina#call',
} as const;

export function ConsultationTeaser() {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage?.split('-')[0];
  const href = language === 'en' ? destinations.en : destinations.de;

  return (
    <section className="mb-16 overflow-hidden rounded-2xl md:grid md:grid-cols-2">
      <img
        className="aspect-[4/3] h-full w-full object-cover"
        src="/christina39.webp"
        alt={t('consultation-teaser.image-alt')}
      />

      <div className="flex flex-col justify-center gap-6 bg-brand-green-700 p-8 text-white md:p-12 lg:px-16">
        <div className="space-y-5">
          <p className="text-sm font-semibold uppercase tracking-wider">
            {t('consultation-teaser.eyebrow')}
          </p>

          <h2 className="font-serif text-3xl leading-tight">
            <a
              className="rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
              href={href}
            >
              {t('consultation-teaser.title')}
            </a>
          </h2>

          <p className="font-light leading-relaxed">
            {t('consultation-teaser.description')}
          </p>
        </div>

        <div>
          <a
            className="inline-flex rounded-full bg-[rgb(216_204_188)] px-6 py-3 font-semibold text-brand-cashmere-900 transition-colors hover:bg-[rgb(202_188_169)] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
            href={href}
          >
            {t('consultation-teaser.action')}
          </a>
        </div>
      </div>
    </section>
  );
}
